module.exports = __webpack_public_path__ + "static/media/palomaTransparent.70e4904a.png";